'use strict';
import { module } from '../app';
import * as _ from 'lodash';
import { constantStrings } from "../constants/constantStrings";

module
  .factory('diagramEditingModel', [
    'Diagram', 'Patient', '$location', 'modalService', 'eventsMgr', '$ionicLoading', '$rootScope',
    'signalrService', 'techpadInitialConfigProvider', 'techpadConfig',
    function (Diagram, Patient, $location, modalService, eventsMgr, $ionicLoading, $rootScope,
      signalrService, techpadInitialConfigProvider, techpadConfig) {
      function diagramEditingModel() {
        let self = this;

        self.diagramImage = null;
        self.DiagramDescription = null;
        self.diagramFullscreen = false;
        self.findingEditing = false;
        self.isOnline = () => signalrService.isConnected;

        self.visitReasons = [];
        self.tecknologists = [];
        self.svg = null;
        self.problems = [];
        self.problemsList = [];
        self.patient = null;


        self.diagramEditor = null;
        self.techpadConfig = techpadConfig;

        self.onDiagramEditorReady = function (diagramEditor) {
          self.diagramEditor = diagramEditor;
        };

        self.showMessage = (message) => {
          return modalService.showAlertAsync(message);
        };

        self.onDiagramError = (message) => {
          if (!message)
            return;

          modalService.showAlert(message, undefined);
        };

        self.showConfirmationMessage = (message) => {
          return modalService.showConfirmationAsync(message);
        };

        $ionicLoading.show({
          template: constantStrings.DefaultLoaderMessage
        });

        self.toggleDiagramFullscreen = function () {
          self.diagramFullscreen = !self.diagramFullscreen;
          eventsMgr.send(constantStrings.DiagramFullScreenEventName, self.diagramFullscreen);
        };

        eventsMgr.on(constantStrings.DiagramFullScreenEventName, function (params, value) {
          self.diagramFullscreen = value;
        });

        self.failLoading = function (resp) {
          $ionicLoading.hide();
          modalService.showErrorMessage(resp.data, resp.status).then(function () {
            $location.path('/root/worklist');
          });
        };

        self.getPatient = function () {
          return Patient.get(self.ssn)
            .then(function (response) {
              self.patient = response.data;
              return response.data;
            })
            .catch(function (error) {
              const errorObject =
                (error && (error.data || error)) ||
                constantStrings.DefaultDiagramLoadError;
              modalService.showErrorMessage(errorObject, null, true);
              throw error;
            });
        };

        self.reloadDiagram = function () {
          let promise = Diagram.get(self.ssn, self.sdate);

          return promise
            .then(function (resp) {
              if (resp.data != null) {
                if (resp.data.IsSDiagramNotCarriedForward) {
                  modalService.showAlert(constantStrings.DiagramCarryForwardImageMissing);
                }
                self.fillDiagramProblems(resp.data.Problems);
              }
            }, async function (errorResp) {
              $ionicLoading.hide();
              const errorObject = errorResp && (errorResp.data || errorResp) || constantStrings.DefaultDiagramLoadError;
              await modalService.showErrorMessage(errorObject, null, true);
              if (techpadInitialConfigProvider.closeApp && _.isFunction(techpadInitialConfigProvider.closeApp)) {
                techpadInitialConfigProvider.closeApp();
              }
            })
            .finally(function () {
              self.problemLoaded = true;
            });
        };

        self.fillDiagramProblems = function (problems) {
          $rootScope.safeApply(function () {
            self.problemsList = [];
            if (problems && problems.length > 0) {
              problems.forEach(function (item) {
                item.Settings = JSON.parse(item.Settings);
              });

              self.problemsList = self.problemsList.concat(problems);

              self.problemsListCopy = _.cloneDeep(self.problemsList);
            }
          });
        };

        self.updateOnlineStatus = function (data) {
          self.isOnline = data.isOnline;
          if (!self.isInitialViewOnly) {
            showAlert(data);
          }

          function showAlert(data) {
            if (data.isOnline) {
              modalService.showAlert('Connection established. You are in online mode.', undefined, 'offline-mode-message');
            } else {
              if (data.internetAvailable) {
                modalService.showAlert('Connection to Portal is not available. Going to offline mode.', undefined, 'offline-mode-message');
              } else {
                modalService.showAlert('Internet connection is not available. Going to offline mode.', undefined, 'offline-mode-message');
              }
            }
          }
        };

        self.refreshData = function () {
          $ionicLoading.hide();

          if (!self.patient.Study) {
            modalService.showAlert('This study record not found in database');
            $location.path('/root/worklist');
            return;
          }

          if (self.patient.Study.IsLinked) {
            self.isLinked = true;
          }

          self.patient.Study.Problems.forEach(function (problem) {
            let item = self.findByCode(problem.Code, self.problems);
            if (!item) {
              return;
            }
            item.IsRight = problem.IsRight;
            item.IsLeft = problem.IsLeft;
            item.IsUnspecified = problem.IsUnspecified;
          });
          self.problemsCopy = angular.copy(self.problems);
          self.finishLoading = true;
        };

        self.prepareSaveDiagram = async function () {
          self.showDiagramSaveResult = true;
          $ionicLoading.show({
            template: 'Saving Diagram...'
          });
          eventsMgr.send('diagram:startSaving');
          let problems = _.cloneDeep(self.problemsList);
          problems.forEach((item) => {
            item.Settings = JSON.stringify(item.Settings);
          });
          let model = {
            ssn: self.ssn ? self.ssn : self.patient.Ssn,
            sdate: self.sdate ? self.sdate : self.patient.SDate,
            worklistId: self.worklistId ? self.worklistId : 0,
            Problems: problems
          };
          const problemsListMapped = _.map(self.problemsList, function (problem) {
            return {
              Id: problem.Id,
              Settings: {
                x: problem.Settings.x,
                y: problem.Settings.y,
                scale: problem.Settings.scale,
                width: problem.Settings.width,
                height: problem.Settings.height,
                newMode: problem.Settings.newMode,
              },
              Type: problem.Type,
              Comments: problem.Comments
            };
          });
          model.IsDiagramChanged = !angular.equals(self.problemsListCopy, problemsListMapped);
          model.IsDiagramEmpty = self.problemsList && self.problemsList.length === 0;
          model.SvgDiagramImage = await self.diagramEditor.getDiagramImageSvgString();
          model.Base64String = await self.diagramEditor.getDiagramImage();
          model = await Diagram.prepareSaveModelWithDiagramImage(model);
          await self.saveDiagram(model);
        };

        self.saveDiagram = function (model) {
          Diagram.saveForPatientWithModel(model).then(async function (resp) {
            if (resp && resp.data && resp.data.NeedGeneratedImageFromClient) {
              model.IsDiagramChanged = true;
              model.NeedGeneratedImageFromClient = true;
              model.SvgDiagramImage = await self.diagramEditor.getDiagramImageSvgString();
              model.Base64String = await self.diagramEditor.getDiagramImage();
              model = await Diagram.prepareSaveModelWithDiagramImage(model);
              resp = await Diagram.saveForPatientWithModel(model);
            }

            $ionicLoading.hide();

            resp.data.Problems.forEach(function (item) {
              item.Settings = JSON.parse(item.Settings);
            });

            self.problemsList = _.cloneDeep(resp.data.Problems);
            self.problemsListCopy = _.cloneDeep(resp.data.Problems);

            if (self.showDiagramSaveResult) {
              modalService.showAlert('Diagram saved successfully', function () {
                if (techpadInitialConfigProvider.closeApp && _.isFunction(techpadInitialConfigProvider.closeApp)) {
                  techpadInitialConfigProvider.closeApp();
                }
              });
            }
          }, function (resp) {
            $ionicLoading.hide();
            modalService.showErrorMessage(resp.data, resp.status);
          });
        };

        self.setSvgAction = function (svg) {
          self.svg = svg;
        };

        if ($rootScope.diagramEditorOnReadyToSave) {
          $rootScope.diagramEditorOnReadyToSave.unsubscribe();
        }

        let diagramEditorOnReadyToSave = eventsMgr.on('diagram:readyToSave', function (scope, base64Data) {
          self.saveDiagram(base64Data);
        });

        let diagramProblemUpdated = eventsMgr.on('diagram:list:updated', function (scope, data) {
          self.problemsList = data;
        });

        self.onDestroy = function () {
          diagramProblemUpdated.unsubscribe();
          diagramEditorOnReadyToSave.unsubscribe();
        };

        self._initWithPatientData = function (ssn, sdate) {
          self.ssn = ssn;
          self.sdate = sdate;

          self.__initialize();
        };

        self.__initialize = async function () {
          self.finishLoading = false;

          await Promise.all([
            self.reloadDiagram(),
            self.getPatient(),
            //self.reloadDiagramImage()
          ]);

          $ionicLoading.hide();
          self.finishLoading = true;
        };
      }

      return diagramEditingModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/diagramEditingModel.js